import React from 'react';
import { useSelector } from 'react-redux';
import SponsorshipBonusesTable from '../../../../components/Marketing/components/SponsorshipBonusesTable';
import { EXTERNAL_SPONSORSHIP_CGU_URL } from '../../../../../../shared/helpers/sponsorshipHelper';

const Dashboard = () => {
  const { sponsorships } = useSelector((state) => state.sponsorshipModule);

  return (
    <div className='w-full md:w-1/2 flex flex-col items-center justify-between gap-5 p-7 border border-ih-purple-20 rounded-3xl bg-white' data-testid='Dashboard'>
      <p className='text-ih-indigo h4 text-center'>
        Plus vous parrainez, plus vous gagnez !
      </p>

      <div className='flex flex-col items-center justify-between gap-5 p-5 border border-ih-purple-20 rounded-3xl'>
        <div className='flex flex-col items-center justify-center'>
          <p className='text-ih-indigo font-medium text-sm'>
            Vos parrainages
          </p>

          <p className='h2 text-ih-blue'>
            {sponsorships.length === 0 ? '0' : `${sponsorships.length.toString().padStart(2, '0')}`}
          </p>
        </div>
      </div>

      <div className='flex flex-col md:flex-row md:flex-wrap gap-3 justify-center'>
        <div className='flex flex-col items-center gap-3 border border-ih-purple-20 rounded-2xl p-3'>
          <p className='font-medium'>Acte authentique</p>

          <SponsorshipBonusesTable className='text-base' />
        </div>
      </div>

      <a href={EXTERNAL_SPONSORSHIP_CGU_URL} className='text-center underline font-semibold text-sm' target='_blank'>
        Termes et conditions de parrainage
      </a>
    </div>
  )
};

export default Dashboard;
